/**
 * @generated SignedSource<<4f5230f70295df0779cce3e9cbb4f2dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditQuery$variables = {
  id: string;
};
export type EmployeeRoleEditQuery$data = {
  readonly employeeRole: {
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditForm_employeeRole">;
  } | null;
};
export type EmployeeRoleEditQuery = {
  response: EmployeeRoleEditQuery$data;
  variables: EmployeeRoleEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeRoleEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmployeeRole",
        "kind": "LinkedField",
        "name": "employeeRole",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmployeeRoleEditForm_employeeRole"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeeRoleEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmployeeRole",
        "kind": "LinkedField",
        "name": "employeeRole",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "employees",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "04d62689d6a91705540292901c9dee95",
    "id": null,
    "metadata": {},
    "name": "EmployeeRoleEditQuery",
    "operationKind": "query",
    "text": "query EmployeeRoleEditQuery(\n  $id: ID!\n) {\n  employeeRole(id: $id) {\n    ...EmployeeRoleEditForm_employeeRole\n    id\n  }\n}\n\nfragment EmployeeRoleEditForm_employeeRole on EmployeeRole {\n  id\n  name\n  team {\n    id\n  }\n  employees {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b1dc1a2a5329767a06f110e44f86939";

export default node;
